import React, { useState } from 'react';
import "../styles/LoginForm.css";
import { useNavigate } from 'react-router-dom';

function CreateUser() {  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();  

  const handleSubmit = async (e) => {
    e.preventDefault();  // Prevent the default form submission behavior

    setLoading(true);  // Set loading state to true
    setError('');      // Reset any previous error

    const userData = { email, password };  // Collect the form data

    try {
      // Make API call to backend (ensure the endpoint is correct)
      const response = await fetch('/api/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      const data = await response.json(); // Parse the response JSON

      if (response.ok) {
        // User created successfully
        console.log('User created successfully:', data.message);
        navigate('/login'); // Redirect to login page after successful account creation
      } else {
        // If creation failed, show error message
        setError(data.message);
      }
    } catch (err) {
      // Handle any errors, such as network errors
      setError('An error occurred. Please try again.');
      console.error('Error:', err);
    } finally {
      setLoading(false); // Set loading to false when the process is complete
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Create Account</h2> {/* Title of the form */}
        
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}  // Update email state on change
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}  // Update password state on change
            required
          />
        </div>

        {error && <p className="error-message">{error}</p>} {/* Display error if exists */}

        <button type="submit" className="login-button" disabled={loading}>
          {loading ? 'Creating Account...' : 'Create Account'} {/* Change button text based on loading state */}
        </button>
      </form>
    </div>
  );
}

export default CreateUser;  
